export const textConstants = {
    open_sidebar: "Open sidebar",
    search: "Search",
    notification: "Notification",
    open_user_menu: "Open user menu",
    settings: "Settings",
    close_panel: "Close panel",
    sandbox_url: "Sandbox URL",
    copy_link: "Copy link",
    learn_more_about_sharing: "Learn more about sharing",
    cancel: "Cancel",
    save: "save",
    preview_sandbox: "Preview sandbox",
    close_sidebar: "Close sidebar",
    invalid_url: "Invalid URL",
    optional: "optional",
    invite_team: "Invite team",
    invite_team_tooltip: "👋🏼 Hey there! invite or collaborate with your team members and accelerate 💪",
    invite_team_members: "Invite team members",
    invite_team_members_description: "Invite your team and work together more efficiently",
    add_invitee: "Add invitee",
    add_people_team: "Add People Or Team",
    add_comments: "Add Comments",
    asignee: "Asignee",
    asign_to: "Assign to",
    watchers: "Watchers",
    pending_invitation: "Pending Invitation",
    invite: "Invite",
    see_past_invites: "See past invites",
    all_tasks: "All tasks",
    filter_by: "filter by",
    my_tasks: "My tasks",
    todo: "Todo",
    show_all: "Show all",
    in_progress: "In Progress",
    completed: "Completed",
    invite_members_select_description: "you can add multiple people, team or invite new members by their email",
    create_new_team: "Create new team",
    invite_member_add_items: "Add Items",
    keep_typing_text: "keep typing to invite them",
    members: "Members",
    successfully_invited_text: "Successfully invited your team",
    invite_member_notify_text: "Once the newly invited team members joins, we will notify you.",
    add: "Add",
    invite_member_team_name: "Team name",
    done: "Done",
    create_team_modal_button_text: "Create",
    team_and_role_warning_text: "Please add a team and role",
    invalid_email_text: "Please enter a valid email address",
    joyride_step_one_text: "You can see the tasks here. Let’s view your tasks.",
    joyride_step_two_text: "Here is your assigned tasks. Once you ready, change the status todo to in-progress",
    project_title: "PLG CRM",
    GET_HELP_FROM_TEAM: "Get help from team",
    EDIT_TEXT: "Edit Name",
    DUPLICATE: "Duplicate",
    EDIT_NAME: "Edit Name",
    WORKFLOWS: "Workflows",
    HOME: "Home",
    DEV: "DEV",
    CUSTOMIZE_ENRICH_ATTRIBUTES: "Customize Enrich Attributes",
    SEARCH_FOR_EMAIL_ID: "Search for email id",
    SEARCH_FOR_COMPANY_NAME_OR_URL: "Search for company name or url",
    ENTER_EMAIL_ID: "Enter email id",
    ENTER_COMPANY_NAME: "Enter company name",
    VERIFY_AND_REDIRECT: "Verifying and Redirecting...",
    VERIFICATION_FAILD: "Verification Failed",
    INVITE_SUCCESS_MSG: "User invited successfully",
    INVITE_SUCCESS_DECS: "An invitation mail successfully sent.",
    INVITE_ERROR_MSG: "User invite operation failed",
    INVITE_ERROR_DECS: "User invite operation failed due to technical error.",
};

export const TITLE_TEXT = {
    CONFIGURE_MESSAGE_QUEUE: "Configure Your Messaging Queue",
    STEALTH_SAAS_MESSAGE_QUEUE: "Stealth SaaS’s Messaging Queue",
    SELECT_YOUR_INTEGRATION: "Select your integration",
    SELECTED_TEMPLATE_PREVIEW: "Selected Template Preview",
    SANDBOX_SETTINGS: "Sandbox Settings",
    CUSTOM_DOMAIN_SETTINGS: "Custom Domain Settings",
    URL_SETTINGS: "URL Settings",
    IDP_SETTINGS: "IDP Settings",
    EMAIL_TEMPLATE: "Email Template",
    EMAIL_PROVIDER: "Email Provider",
    CONFIGURE_YOUR_CUSTOMER_NOTIFICATION: "Configure your customer notification",
    EVENT_BASED_NOTIFICATION: "Event Based Notification",
    NOTIFY_CUSTOMER: "Notify Customer",
    INTERNAL_NOTIFY: "Internal Notify",
    ENRICH_ORGANIZATION: "Enrich Organization"
};

export const MESSAGE_TEXT = {
    SELECT_YOUR_INTEGRATION_SUBTITLE: "Clearbit service added for user enrichment in DEV environment by default.",
    CUSTOMIZE_ENRICH_ORG_ATTRIBUTES: "Customize the enrich organization attributes",
    CUSTOMIZE_ENRICH_USER_ATTRIBUTES: "Customize the enrich user attributes",
    WANT_TO_PUBLISH_CUSTOM_DOMAIN: "Want to publish this to a custom domain?",
    SETUP_INTERNAL_NOTIFICATION: "Setup Internal Notification",
    NOTIFY_INTERNAL_TEAM: "This will allow your internal team to be notified on various signup events.",
    SLACK_CHANNEL_REQUIREMENT: "requires your team’s slack authorization and #channel for notification",
    SETUP_GUIDE_FOR_INTERNAL_NOTIFICATION: "Setup Guide for Internal Notification",
    HOW_TO_CREATE_SLACK_CHANNEL: "How to create a slack channel",
    SIGNUP_PAGE_SOCIAL_VALIDATION_TITLE: " ThriveStack Empowers Your Product's PLG Success"
};

export const LABELS = {
    CONFIGURATION_VARIABLE: "Configuration Variable",
    SELECT_PROVIDER: "Select Provider",
    ENDPOINT_URL: "Endpoint URL",
    AWS_REGION: "AWS Region",
    DYNAMIC_ACCESS_KEY_ID: "Dynamic Access Key ID",
    DYNAMIC_SECRET_ACCESS_KEY_ID: "Dynamic Secret Access Key ID",
    QUEUE_URL: "Queue URL",
    DELAY_SECONDS: "Delay Seconds",
    PAYLOAD: "Payload",
    INTEGRATION: "Integration",
    CLIENT_ID: "Client ID",
    CLIENT_SECRET: "Client Secret",
    SECRET_KEY: "Secret Key",
    ENRICH_ORG_DATA_SOURCE: "Enrich Org Data Source",
    EMAIL: "Email",
    COMPANY_URL: "Company URL",
    ENTER_MESSAGE_TITLE: "Enter Message Title",
    ENTER_MESSAGE_SUBTITLE: "Enter Message Subtitle",
    ENTER_BUTTON_TEXT: "Enter Button Text",
    SANDBOX_URL: "Sandbox URL",
    TRIGGER_TYPE: "Trigger Type",
    PATH: "Path",
    QUERY_PARAMETERS: "Query Parameters",
    ENTER_REDIRECT_URL: "Enter Redirect URL",
    IDENTITY_PROVIDER: "Identity Provider",
    AUTH0_TENANT_NAME: "Auth0 Tenant Name",
    DOMAIN_URL: "Domain URL",
    APP_ORIGIN: "App Origin",
    API_ORIGIN: "API Origin",
    API_KEY: "API Key",
    ENTER_EMAIL_PROVIDER: "Enter Email Provider",
    WHEN_TENANT_CREATED: "When Tenant Created",
    WHEN_END_USER_SIGNUP: "When End User Signup",
    USE_DATA_FROM_SIGNUP_PAGE: "Use data from signup page",
    USE_DATA_FROM_ONBOARDING: "Use data from onboarding",
    ASSIGNEE: "Assignee",
    WATCHERS: "Watchers",
    SELECTED_TEMPLATE: "Selected Template",
    PAGE: "Page",
    VARIABLE_NAME: "Variable Name",
    KEY: "Key",
    VALUE: "Value",
    TYPE: "Type",
    SCOPE: "Scope",
    SOURCE: "Source"
};

export const PLACEHOLDERS = {
    SELECT_OPTION: "Select a Option",
    SELECT_YOUR_PROVIDER: "Select your provider",
    ENTER_ENDPOINT_URL: "Enter your endpoint URL",
    SELECT_YOUR_REGION: "Select your region",
    ENTER_YOUR_ACCESS_KEY_ID: "Enter your access key ID",
    ENTER_YOUR_SECRET_ACCESS_KEY_ID: "Enter your secret access key ID",
    ENTER_YOUR_QUEUE_URL: "Enter your queue URL",
    ENTER_YOUR_DELAY_SECONDS: "Enter your delay seconds",
    REDIRECT_URL: "Redirect URL",
    ENTER_EMAIL_PROVIDER: "Enter your email provider",
    ENTER_COMPANY_URL: "Enter Company URL",
    ENTER_EMAIL: "Enter Email",
    SELECT: "Select"
};

export const BUTTON_TEXT = {
    VERIFY: "Verify",
    SAVE: "Save",
    CUSTOMIZE: "Customize",
    CONFIGURE_YOUR_CUSTOM_DOMAIN: "Configure your custom domain",
    TEST_WITH_SANDBOX_URL: "Test With Sandbox URL",
    TEST_WITH_CUSTOM_DOMAIN: "Test With Custom Domain",
    TEST_IDP: "Test IDP",
    CONTINUE: "Continue",
    RESET: "Reset",
    COPY: "Copy",
    OPEN: "Open",
    GET_HELP: "Get Help",
    CANCEL: "cancel",
    EDIT: "Edit",
    CLOSE: "Close",
    NEED_HELP: "Need Help?",
    ENABLE_SLACK_NOTIFICATION: "Enable Slack Notification"
};

export const TABS_TEXT = {
    CONFIGURATION: "Configuration",
    ERROR_HANDLING: "Error Handling",
    TEST: "Test"
};

export const STEPS_TEXT = {
    DOMAIN_NAME_TEXT: "Your Domain Name",
    ADD_CNAME: "Add Below CNAME records into the DNS configuration for example.com",
    CNAME_RECORD_VERIFICATION: "CNAME Record for verification",
    CNAME_RECORD_REDIRECTION: "CNAME Record for Redirection",
    VERIFY_RECORD: "Verify Below",
    VERIFIED: "Verified",
    WAITING_INFO_TEXT: "this will take few hours",
    HOST_LABEL: "Host/Label",
    DESTINATION_TARGET: "Destination/Target"
};

export const VARIABLES = {
    TEMPLATE_CONFIG: "template_config"
};

export const BRAND_TEXT = {
    PLATFORM_BRAND_NAME: "ThriveStack"
};
